import { ConditionEvaluator } from '@leverege/condition';
import Path from '@leverege/path';
import Attributes from "../attribute/Attributes.js";
const nullOp = () => null;
export default class AttributeEvaluator extends ConditionEvaluator {
  constructor(model, factory) {
    super(model, factory);
    const contextPath = model.contextPath ? model.contextPath.trim() : null;
    this.path = Path(contextPath);
    this.comparatorEvaluator = factory.create(this.model.comparator, factory) || {
      satisfies: nullOp
    };
  }

  /**
    * Determines whether the target satisfies the model is met or not given the context
    * @param {*} context The context with which the satisfies method is to be executed
    * @return {boolean or null} depending on whether the data fields are known. Null means that it is
    * unclear if the target satisfies the condition
    */
  satisfies(context) {
    const target = this.path.get(context);
    const attribute = Attributes.getAttribute(this.model.attrName, target?.type);
    return this.comparatorEvaluator.satisfies({
      ...context,
      attribute,
      target
    });
  }
}